/** Sections the Tasks Hub groups async items into. */
export enum TasksHubSection {
    NeedsAttention = 'needsAttention',
    InProgress = 'inProgress',
    ReadyToReview = 'readyToReview',
}
